export default __webpack_public_path__ + "img/49fa54959e27d02b0dc51af23e858460.svg";